import { useTranslation } from "react-i18next";
import getPriceForChosenDuration from "helpers/getPriceForChosenDuration";
import styles from "./styles.module.scss";
import getDiscountedPriceForChosenDuration from "helpers/getDiscountPriceForChosenDuration";

const PricesTable = ({ space, direction = "column" }) => {
  const { t } = useTranslation("global");

  const priceOptions = [
    { label: t("space.byHourFull"), duration: "hour" },
    { label: t("space.byHalfDayFull"), duration: "half_day" },
    { label: t("space.byDayFull"), duration: "day" },
    { label: t("space.byWeekFull"), duration: "week" },
    { label: t("space.byMonthFull"), duration: "month" },
    { label: t("space.residential"), duration: "residential" },
  ];

  // Only show durations that have valid prices (not null)
  const getVisiblePriceOptions = () => {
    return priceOptions.filter(({ duration }) => {
      const price = getPriceForChosenDuration(space, duration, t, false);
      return price !== null && parseFloat(price) > 0;
    });
  };

  const visibleOptions = getVisiblePriceOptions();

  // Don't show the table if no prices available
  if (visibleOptions.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.prices} ${styles[direction]}`}>
      <p className={styles.title}>{t("space.tarifs")}</p>
      <div className={`${styles.table}`}>
        {visibleOptions.map(({ label, duration }, index) => {
          const regularPrice = getPriceForChosenDuration(
            space,
            duration,
            t,
            false
          );
          const lastMinutePrice =
            space.last_minute &&
            getDiscountedPriceForChosenDuration(space, duration, t, false);

          return (
            <div className={styles.item} key={index}>
              <span className={styles.label}>{label}</span>
              <span className={styles.value}>
                {space.last_minute && regularPrice && (
                  <span className={styles.crossedOut}>{regularPrice}</span>
                )}
                {lastMinutePrice || regularPrice}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PricesTable;